import React from 'react';
import PropTypes from 'prop-types';
import { FilterSection } from './filter_section';
import { FilterCheckbox } from './filters/filter_checkbox';
import { Filters } from '../../../../constants/filter/filters';
import { FilterLabelTranslationKeys } from '../../../../constants/filter/filter_label_translation_keys';
import TranslationContainer from '../../../translation/translation_container';

function QualitySegment(props) {
    const qualitySegmentHasValue = props.qualitySegmentPremiumValue || props.qualitySegmentValueValue || props.qualitySegmentBudgetValue;
    const opened = props.opened || qualitySegmentHasValue;

    return (
        <FilterSection
            opened={opened}
            resettable={props.resettable}
            onActionClick={props.onActionClick}
            headline='catalog-filters-section-headline-quality-segment'
            containerModifier="quality_segment"
            scrollable={true}
        >
            <TranslationContainer targetProperties={{
                tooltipContent: {
                    translationKey: props.qualitySegmentPremiumEnabled ?
                        'catalog-filters-quality-segment-premium-tooltip' :
                        'catalog-filters-conditional-option-disabled'
                }
            }}>
                <FilterCheckbox
                    name={Filters.QUALITY_SEGMENT_PREMIUM}
                    checked={props.qualitySegmentPremiumValue}
                    labelTranslationKey={FilterLabelTranslationKeys[Filters.QUALITY_SEGMENT_PREMIUM]}
                    tooltipContent="will-be-replace"
                    onChange={props.onQualitySegmentChange}
                    onToolTipHover={() => props.onToolTipHover('Premium')}
                    disabled={!props.qualitySegmentPremiumEnabled}
                />
            </TranslationContainer>

            <TranslationContainer targetProperties={{
                tooltipContent: {
                    translationKey: props.qualitySegmentValueEnabled ?
                        'catalog-filters-quality-segment-value-tooltip' :
                        'catalog-filters-conditional-option-disabled'
                }
            }}>
            <FilterCheckbox
                name={Filters.QUALITY_SEGMENT_VALUE}
                checked={props.qualitySegmentValueValue}
                labelTranslationKey={FilterLabelTranslationKeys[Filters.QUALITY_SEGMENT_VALUE]}
                tooltipContent="will-be-replace"
                onChange={props.onQualitySegmentChange}
                onToolTipHover={() => props.onToolTipHover('Value')}
                disabled={!props.qualitySegmentValueEnabled}
                />
            </TranslationContainer>

            <TranslationContainer targetProperties={{
                tooltipContent: {
                    translationKey: props.qualitySegmentBudgetEnabled ?
                        'catalog-filters-quality-segment-budget-tooltip' :
                        'catalog-filters-conditional-option-disabled'
                }
            }}>
                <FilterCheckbox
                    name={Filters.QUALITY_SEGMENT_BUDGET}
                    checked={props.qualitySegmentBudgetValue}
                    labelTranslationKey={FilterLabelTranslationKeys[Filters.QUALITY_SEGMENT_BUDGET]}
                    tooltipContent="will-be-replace"
                    onChange={props.onQualitySegmentChange}
                    onToolTipHover={() => props.onToolTipHover('Budget')}
                    disabled={!props.qualitySegmentBudgetEnabled}
                />
            </TranslationContainer>

        </FilterSection>
    );
}

QualitySegment.propTypes = {
    opened: PropTypes.bool.isRequired,
    resettable: PropTypes.bool.isRequired,
    onActionClick: PropTypes.func.isRequired,
    onQualitySegmentChange: PropTypes.func.isRequired,

    qualitySegmentPremiumValue: PropTypes.bool.isRequired,
    qualitySegmentValueValue: PropTypes.bool.isRequired,
    qualitySegmentBudgetValue: PropTypes.bool.isRequired,

    qualitySegmentPremiumEnabled: PropTypes.bool.isRequired,
    qualitySegmentValueEnabled: PropTypes.bool.isRequired,
    qualitySegmentBudgetEnabled: PropTypes.bool.isRequired,
};

export { QualitySegment };
